import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgBrandheroSadLight = (props) => /* @__PURE__ */ _jsxs("svg", {
	id: "Layer_1",
	"data-name": "Layer 1",
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 287.99 378.89",
	...props,
	children: [
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("style", { children: "\n      .cls-1 {\n        fill: #1c70e8;\n        stroke-width: 4px;\n      }\n\n      .cls-1, .cls-2, .cls-3 {\n        stroke: #001321;\n        stroke-miterlimit: 10;\n      }\n\n      .cls-2 {\n        fill: #ec1c24;\n      }\n\n      .cls-2, .cls-3 {\n        stroke-width: 2px;\n      }\n\n      .cls-4, .cls-3 {\n        fill: #fff;\n      }\n\n      .cls-5, .cls-6 {\n        fill: #001321;\n      }\n\n      .cls-7 {\n        fill: #d0dffe;\n      }\n\n      .cls-6 {\n        opacity: .3;\n      }\n    " }) }),
		/* @__PURE__ */ _jsx("path", {
			className: "cls-1",
			d: "M138.56,364.96v-19.12h-3.26l-.4,19.12h-65.61s-28.27-39.06-29.49-70.79c-.04-.96-.06-1.95-.06-2.98-.01-.34-.01-.69-.01-1.04,0-1.69.04-3.47.11-5.31.16-4.43.52-9.27,1.04-14.42,2.7-26.78,9.78-61.91,17.02-90.78,2.13-8.46,4.26-16.38,6.31-23.4,6.18-21.16,10-44.63,23.61-62.63,19.19-25.37,59.93-28.04,84.78-9.89,22.48,16.42,25.79,47.78,32.99,72.52,1.99,6.84,4.07,14.53,6.15,22.76,7.29,28.98,14.46,64.41,17.18,91.39.74,7.31,1.15,13.99,1.15,19.76,0,.35,0,.7-.01,1.04,0,1.03-.02,2.02-.06,2.98-1.22,31.73-28.54,70.79-28.54,70.79h-62.9Z"
		}),
		/* @__PURE__ */ _jsxs("g", { children: [/* @__PURE__ */ _jsx("path", {
			className: "cls-7",
			d: "M137.32,327.67c-.35,0-.69,0-1.04-.01-12.11-.29-24.71-4.79-34.58-12.34-14.31-10.95-22.86-28.23-22.86-46.24,0-15.29,6.34-29.83,17.86-40.97,11.13-10.76,25.95-16.93,40.65-16.93,6.92,0,13.68,1.33,20.11,3.97,6.01,2.46,11.64,5.91,17.08,9.25,5.82,3.57,11.83,7.27,18.42,9.83,6.97,2.71,13.8,4.09,20.31,4.09,3.6,0,7.08-.43,10.35-1.29.85,4.18,3.96,20.47,4.8,38.76.53,11.62-.25,23.04-.55,26.85-5.32-2.02-10.56-3-15.97-3-15.17,0-28.82,7.97-41.5,16.13-9.59,6.18-20.24,11.89-33.06,11.89Z"
		}), /* @__PURE__ */ _jsx("path", {
			className: "cls-5",
			d: "M137.34,212.18c6.78,0,13.42,1.31,19.73,3.89,5.93,2.43,11.53,5.86,16.93,9.18,5.86,3.6,11.91,7.31,18.58,9.91,7.08,2.76,14.04,4.15,20.67,4.15,3.31,0,6.53-.36,9.58-1.07,1.05,5.36,3.8,20.61,4.57,37.59.48,10.44-.11,20.73-.45,25.41-5.01-1.75-9.96-2.61-15.07-2.61-15.45,0-29.24,8.05-42.04,16.29-9.46,6.09-19.96,11.73-32.52,11.73-.34,0-.68,0-1.02-.01-11.9-.29-24.29-4.71-34-12.14-14.07-10.76-22.47-27.75-22.47-45.44,0-15.01,6.23-29.31,17.56-40.25,10.95-10.58,25.51-16.65,39.95-16.65M137.34,210.18c-30.9,0-59.51,26.26-59.51,58.89,0,18.32,8.7,35.9,23.25,47.03,9.9,7.57,22.68,12.24,35.17,12.55.36,0,.71.01,1.06.01,12.52,0,23.22-5.37,33.6-12.05,13.16-8.48,26.38-15.97,40.96-15.97,5.41,0,11,1.03,16.85,3.43,0,0,1.33-13.92.67-28.32-.98-21.49-5.03-39.97-5.03-39.97-3.62,1.06-7.36,1.54-11.12,1.54-6.77,0-13.61-1.55-19.94-4.02-12.67-4.93-22.98-13.96-35.48-19.08-6.76-2.76-13.68-4.04-20.49-4.04h0Z"
		})] }),
		/* @__PURE__ */ _jsxs("g", { children: [/* @__PURE__ */ _jsx("path", {
			className: "cls-7",
			d: "M136.6,193.99c-6.56,0-12.98-1.05-19.09-3.13-5.7-1.94-11.03-4.66-16.19-7.29-5.51-2.81-11.21-5.72-17.44-7.73-6.6-2.13-13.06-3.21-19.2-3.21-1.34,0-2.67.05-3.97.16l13.48-48.67c11.31-1.8,21.95-7.14,31.07-12.02,9.1-4.87,19.21-9.37,31.36-9.37.33,0,.66,0,1,.01,11.49.23,23.44,3.78,32.8,9.72,13.5,8.58,21.57,22.1,21.57,36.18,0,11.94-5.98,23.31-16.84,32.03-10.55,8.47-24.59,13.33-38.54,13.33h0Z"
		}), /* @__PURE__ */ _jsx("path", {
			className: "cls-5",
			d: "M136.62,101.72v2c.32,0,.65,0,.98.01,11.31.23,23.08,3.72,32.29,9.57,13.21,8.39,21.1,21.6,21.1,35.33,0,11.63-5.85,22.73-16.46,31.25-10.37,8.33-24.19,13.11-37.92,13.11-6.46,0-12.77-1.03-18.77-3.07-5.63-1.92-10.93-4.62-16.06-7.23-5.55-2.83-11.28-5.76-17.59-7.8-6.7-2.16-13.27-3.26-19.51-3.26-.88,0-1.76.02-2.63.07l12.93-46.7c11.22-1.92,21.73-7.19,30.75-12.02,8.99-4.81,18.96-9.25,30.89-9.25v-2M136.62,101.72c-11.86,0-21.99,4.23-31.83,9.49-10.2,5.46-20.43,10.4-31.39,12.01l-14.04,50.7c1.76-.2,3.54-.29,5.32-.29,6.41,0,12.89,1.22,18.9,3.16,12,3.88,21.77,10.99,33.62,15.02,6.4,2.18,12.96,3.18,19.41,3.18,29.28,0,56.38-20.67,56.38-46.36,0-14.42-8.24-28.26-22.03-37.02-9.38-5.96-21.48-9.64-33.32-9.88-.34,0-.68-.01-1.02-.01h0Z"
		})] }),
		/* @__PURE__ */ _jsx("path", {
			className: "cls-5",
			d: "M165.35,79.33c-5.38-2.86-11.09-4.8-17.05-5.87-5.93-1.31-12.51-1.6-18.1-4.44-3.79-1.94-7.33-5.07-8.86-9.12,0,0,.33-.23.33-.23,1.67,1.29,3.27,2.39,4.95,3.34,6.92,3.51,14.81,5.82,22.32,7.87,5.93,1.73,11.69,4.45,16.63,8.12,0,0-.21.34-.21.34h0Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "cls-5",
			d: "M174.59,340.46c-22.55,9.87-52.54,9.37-75.19,0,6.32.96,12.58,1.72,18.85,2.28,11.73,1.04,23.47,1.2,35.21.4,1.5-.14,5.49-.51,7.03-.65,4.58-.53,9.56-1.36,14.11-2.03h0Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "cls-3",
			d: "M125.56,139.56c0,5.15-2.06,9.82-5.39,13.24h-27.19c-3.34-3.42-5.39-8.09-5.39-13.24,0-10.49,8.5-18.99,18.99-18.99s18.98,8.5,18.98,18.99Z"
		}),
		/* @__PURE__ */ _jsx("circle", {
			className: "cls-5",
			cx: 106.58,
			cy: 136.27,
			r: 14.68
		}),
		/* @__PURE__ */ _jsx("ellipse", {
			className: "cls-4",
			cx: 116.2,
			cy: 145.45,
			rx: 5.19,
			ry: 2.9,
			transform: "translate(-69.51 132.39) rotate(-47.36)"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "cls-3",
			d: "M182.68,139.56c0,5.15-2.06,9.82-5.39,13.24h-27.19c-3.34-3.42-5.39-8.09-5.39-13.24,0-10.49,8.5-18.99,18.98-18.99s18.99,8.5,18.99,18.99Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "cls-5",
			d: "M174.94,107.15l-14.33-7.29c-2.07-1.05-3.16-3.27-2.64-5.37l.95-3.88c.32-1.29,2.09-1.62,2.99-.56l13.8,16.23c.43.51-.17,1.19-.78.88Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "cls-5",
			d: "M96.4,107.15l14.33-7.29c2.07-1.05,3.16-3.27,2.64-5.37l-.95-3.88c-.32-1.29-2.09-1.62-2.99-.56l-13.8,16.23c-.43.51.17,1.19.78.88Z"
		}),
		/* @__PURE__ */ _jsx("polygon", {
			className: "cls-6",
			points: "157.78 364.96 138.56 364.96 138.56 360.88 139.47 345.84 153.01 345.6 157.78 364.96"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "cls-5",
			d: "M120.99,171.25c7.46-4.01,17.83-3.83,25.34,0-4.28,1-8.4,1.09-12.68,1.1-4.28-.05-8.36-.24-12.66-1.1h0Z"
		}),
		/* @__PURE__ */ _jsx("circle", {
			className: "cls-2",
			cx: 205.26,
			cy: 80.86,
			r: 5.67
		}),
		/* @__PURE__ */ _jsx("polygon", {
			className: "cls-2",
			points: "234.1 48.22 215.7 38.52 206.34 66.66 216.36 71.94 234.1 48.22"
		}),
		/* @__PURE__ */ _jsx("circle", {
			className: "cls-2",
			cx: 184.86,
			cy: 66.25,
			r: 5.67
		}),
		/* @__PURE__ */ _jsx("polygon", {
			className: "cls-2",
			points: "175.25 23.76 156.62 33.02 173.97 57.07 184.12 52.03 175.25 23.76"
		}),
		/* @__PURE__ */ _jsx("circle", {
			className: "cls-5",
			cx: 163.36,
			cy: 136.27,
			r: 14.68
		}),
		/* @__PURE__ */ _jsx("ellipse", {
			className: "cls-4",
			cx: 172.98,
			cy: 145.45,
			rx: 5.19,
			ry: 2.9,
			transform: "translate(-51.19 174.16) rotate(-47.36)"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "cls-1",
			d: "M214.03,188.35c3.2,6.31,6.08,12.8,8.7,19.37,4.13,10.39,9.83,23.79,7.94,35.23-.42,2.53-1.61,5.04-3.72,6.51-6.27,4.36-19.03,2.02-26.16,1.41-20.96-1.78-44.84-7.12-62.63-18.79-12.02-7.89-16.4-18.72-13.66-32.74.72-3.67,2.22-7.28,4.85-9.93,8.82-8.91,25.08-.48,34.35,3.1,13.47,5.21,25.86,13.29,37.41,21.97"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "cls-1",
			d: "M56.73,188.35c-3.2,6.31-6.08,12.8-8.7,19.37-4.13,10.39-9.83,23.79-7.94,35.23.42,2.53,1.61,5.04,3.72,6.51,6.27,4.36,19.03,2.02,26.16,1.41,20.96-1.78,44.84-7.12,62.63-18.79,12.02-7.89,16.4-18.72,13.66-32.74-.72-3.67-2.22-7.28-4.85-9.93-8.82-8.91-25.08-.48-34.35,3.1-13.47,5.21-25.86,13.29-37.41,21.97"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "cls-6",
			d: "M106.45,312.34c-18.45-18.55-30.57-36.47-36.47-61.47-.18-.78,14.06-2.1,27.8-5.23,13.05-2.98,25.66-7.81,24.43-7.74-38.06,2.22-52.09-7.01-54.61-11.25-11.29-18.99,2.04-41.97,7.97-63.09,4.08-14.55,8.65-29.28,13.23-43.75,6.29-19.87,16.52-39.18,36.9-47.17-14.81,2.01-28.78,8.93-37.89,20.97-13.61,18-17.43,41.48-23.61,62.63-2.05,7.02-4.18,14.94-6.31,23.4-1.81,7.22-14.46,38.96-15.45,46.85-2.72,21.74.45,23.84-1.57,43.93-.52,5.15-.88,9.99-1.04,14.42-.07,1.84-.11,3.62-.11,5.31,0,.35,0,.7.01,1.04,0,1.03.02,2.02.06,2.98,1.22,31.73,29.49,70.79,29.49,70.79,0,0,7.65,0,7.65,0h60.06l-2.81-19.12s35.06-3.88,35.07-3.88c-5.17.57-12.18-2.1-17.03-3.45-17.41-4.87-32.99-13.31-45.77-26.17Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "cls-5",
			d: "M26.33,366.27c20.64-.83,41.29-1.26,61.93-1.55,10.32-.18,20.64-.23,30.97-.33l30.97-.11,30.97.1c10.32.11,20.64.15,30.97.33,20.64.29,41.29.73,61.93,1.56-20.64.83-41.29,1.27-61.93,1.56-10.32.19-20.64.22-30.97.33l-30.97.1-30.97-.11c-10.32-.11-20.64-.15-30.97-.33-20.64-.29-41.29-.73-61.93-1.55Z"
		})
	]
});
export default SvgBrandheroSadLight;
